"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllQueryServices = void 0;
// (C) 2021-2022 GoodData Corporation
var queryInsightDateDatasets_1 = require("./queryInsightDateDatasets");
var queryInsightAttributesMeta_1 = require("./queryInsightAttributesMeta");
var queryWidgetFilters_1 = require("./queryWidgetFilters");
var queryMeasureDateDatasets_1 = require("./queryMeasureDateDatasets");
var queryWidgetBrokenAlerts_1 = require("./queryWidgetBrokenAlerts");
var queryWidgetAlertCount_1 = require("./queryWidgetAlertCount");
var queryConnectingAttributes_1 = require("./queryConnectingAttributes");
var queryAttributeByDisplayForm_1 = require("./queryAttributeByDisplayForm");
exports.AllQueryServices = [
    queryInsightDateDatasets_1.QueryDateDatasetsForInsightService,
    queryInsightAttributesMeta_1.QueryInsightAttributesMetaService,
    queryWidgetFilters_1.QueryWidgetFiltersService,
    queryMeasureDateDatasets_1.QueryDateDatasetsForMeasureService,
    queryWidgetBrokenAlerts_1.QueryWidgetBrokenAlertService,
    queryWidgetAlertCount_1.QueryWidgetAlertCountService,
    queryConnectingAttributes_1.QueryConnectingAttributesService,
    queryAttributeByDisplayForm_1.QueryAttributeByDisplayFormService,
];
//# sourceMappingURL=index.js.map